var render = function render(){
  var _vm$suggestedScanLine, _vm$currentOrderCompl;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isLoading ? _c('div', [_c('span', {
    staticClass: "fa fa-spinner fa-spin"
  })]) : _c('div', [_c('b-row', [_c('b-col', [_c('div', {
    staticClass: "accordion"
  }, [_c('b-card', {
    ref: "product-scan",
    staticClass: "mb-1",
    class: {
      'opacity-8': _vm.scannedLine
    },
    attrs: {
      "no-body": ""
    }
  }, [_c('b-card-header', {
    staticClass: "text-left py-2 pl-3"
  }, [_c('b-card-title', {
    staticClass: "m-0 d-block w-100"
  }, [!_vm.scannedLine ? _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_vm._v("SCAN ARTIKEL")]), _c('b-col', {
    staticClass: "text-right pr-2 pr-md-4",
    attrs: {
      "cols": "6"
    }
  }, [!_vm.isUnableToShipMode && _vm.hasPermission('orders.batch.process.sort.mancos') && _vm.isUnableToShipPossible ? _c('a', {
    staticClass: "text-danger font-weight-normal",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        _vm.isUnableToShipMode = true;
      }
    }
  }, [_c('small', [_vm._v("Kan niet leveren")])]) : _vm._e()])], 1) : _c('div', [_vm._v(" GESCAND:"), _c('br'), _c('span', {
    staticClass: "font-weight-normal d-inline-block mt-2"
  }, [_c('product-scanned-info', {
    attrs: {
      "dispatch-request-line": _vm.scannedLine
    }
  })], 1), _vm.scannedLineSalesOrderIdentifier ? _c('small', {
    staticClass: "font-weight-normal d-inline-block mt-2 ml-2 text-black-50"
  }, [_vm._v(" (order: "), _c('b-link', {
    staticClass: "text-black-50",
    attrs: {
      "to": {
        name: 'OrderDetailOverview',
        params: {
          salesOrderIdentifier: _vm.scannedLineSalesOrderIdentifier
        }
      },
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.scannedLineSalesOrderIdentifier))]), _vm._v(") ")], 1) : _vm._e()])], 1)], 1), _c('b-collapse', {
    attrs: {
      "id": "accordion-product-scan",
      "visible": "",
      "accordion": "orderpicking-steps"
    }
  }, [_c('div', {
    staticClass: "accordion"
  }, [_c('b-card-body', {
    staticClass: "p-3"
  }, [_c('b-collapse', {
    attrs: {
      "id": "accordion-product-scan-main",
      "visible": "",
      "accordion": "product-scan-accordion"
    }
  }, [_vm.unableToShipMessage ? _c('div', {
    staticClass: "mb-3"
  }, [_c('small', [_c('font-awesome-icon', {
    staticClass: "text-success mr-1",
    attrs: {
      "icon": "check-circle"
    }
  }), _vm._v(" " + _vm._s(_vm.unableToShipMessage) + " ")], 1)]) : _vm._e(), _c('b-alert', {
    attrs: {
      "show": _vm.isProductScanSuggestionEnabled,
      "variant": "info"
    }
  }, [_vm.suggestedScanLine ? _c('b-row', {
    staticClass: "mb-1"
  }, [_c('b-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('font-awesome-icon', {
    staticClass: "text-warning mr-2",
    attrs: {
      "icon": "lightbulb"
    }
  }), _c('small', [_c('i', [_vm._v(_vm._s(_vm.$t('product-processing.pick-suggestion.title')))])])], 1), _c('b-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "4"
    }
  }, [_c('small', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.click",
      value: _vm.$t('product-processing.pick-suggestion.tooltip-main'),
      expression: "$t('product-processing.pick-suggestion.tooltip-main')",
      modifiers: {
        "click": true
      }
    }],
    staticClass: "text-info"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "question-circle"
    }
  })], 1)])], 1) : _vm._e(), _vm.isLoadingSuggestedScanLines ? _c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  }) : _vm.isSuggestedScanLinesError ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.$t('product-processing.pick-suggestion.error')) + " ")]) : _vm.suggestedScanLine ? _c('show-suggested-scan-line', {
    attrs: {
      "suggested-scan-line": _vm.suggestedScanLine,
      "data-eans": (_vm$suggestedScanLine = _vm.suggestedScanLine.ean_codes) === null || _vm$suggestedScanLine === void 0 ? void 0 : _vm$suggestedScanLine.join('|')
    }
  }) : _c('span', {
    staticClass: "text-primary",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('product-processing.pick-suggestion.no-suggestion-found'))
    }
  })], 1), _c('b-alert', {
    staticClass: "py-1 px-2",
    attrs: {
      "show": !!(_vm.isShowPreviousScannedLineEnabled && _vm.showPreviousScannedLineTimer && _vm.previousScannedLine),
      "variant": "light"
    }
  }, [_c('span', {
    staticClass: "loader"
  }, [_vm._v(_vm._s(_vm.showPreviousScannedLineTimer))]), _c('small', {
    staticClass: "d-block float-left w-75"
  }, [_c('strong', [_vm._v("VORIG GESCANDE ARTIKEL:")]), _c('product-scanned-info', {
    attrs: {
      "dispatch-request-line": _vm.previousScannedLine
    }
  })], 1), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _c('product-scan-sort', {
    key: `${_vm.currentStep}_${_vm.scanCycle}`,
    attrs: {
      "storage-zone-identifier": _vm.storageZoneIdentifier,
      "location": _vm.location,
      "batch-model-type": _vm.batchModelType,
      "batch-model-identifier": _vm.batchModelIdentifier,
      "process-type": _vm.processType
    },
    on: {
      "success": _vm.finishScanProduct
    }
  })], 1), _c('b-collapse', {
    attrs: {
      "id": "accordion-product-scan-unable-to-ship",
      "accordion": "product-scan-accordion"
    }
  }, [_vm.isUnableToShipMode ? _c('unable-to-ship', {
    key: `uts_${_vm.currentStep}_${_vm.scanCycle}`,
    attrs: {
      "storage-zone-identifier": _vm.storageZoneIdentifier,
      "batch-model-type": _vm.batchModelType,
      "batch-model-identifier": _vm.batchModelIdentifier,
      "location": _vm.location,
      "process-type": _vm.processType,
      "suggested-lines": _vm.suggestedScanLines
    },
    on: {
      "close": _vm.closeUnableToShipView
    }
  }) : _vm._e()], 1)], 1)], 1)])], 1), _c('b-card', {
    ref: "special-processing",
    staticClass: "mb-1",
    class: {
      inactive: !_vm.isStepActive('special-processing')
    },
    attrs: {
      "no-body": ""
    }
  }, [_c('b-card-header', {
    staticClass: "text-left py-2 pl-3"
  }, [_c('b-card-title', {
    staticClass: "m-0"
  }, [_vm._v(" SPECIALE VERWERKING "), _vm.isStepActive('special-processing') && _vm.countSpecialProcessingSteps > 1 ? _c('span', [_vm._v(" (" + _vm._s(_vm.countSpecialProcessingSteps - _vm.specialProcessingIdentifiers.length) + "/" + _vm._s(_vm.countSpecialProcessingSteps) + ") ")]) : _vm._e()])], 1), _c('b-collapse', {
    attrs: {
      "id": "accordion-special-processing",
      "accordion": "orderpicking-steps"
    }
  }, [_c('b-card-body', {
    staticClass: "p-3"
  }, [_c('b-collapse', {
    key: _vm.scanCycle,
    attrs: {
      "id": "special-process-container",
      "visible": "",
      "appear": _vm.countSpecialProcessingSteps - _vm.specialProcessingIdentifiers.length !== 1
    }
  }, _vm._l(_vm.SPECIAL_PROCESSES, function (specialProcess) {
    return _c(specialProcess, {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: specialProcess.methods.getIdentifier() === _vm.currentSpecialProcess,
        expression: "specialProcess.methods.getIdentifier() === currentSpecialProcess"
      }],
      key: specialProcess.methods.getIdentifier() + _vm.scanCycle,
      ref: specialProcess.methods.getIdentifier(),
      refInFor: true,
      tag: "component",
      attrs: {
        "batch-model-type": _vm.batchModelType,
        "dispatch-request": _vm.dispatchRequest,
        "scanned-line": _vm.scannedLine,
        "product-identifier": _vm.productIdentifier,
        "location": _vm.location,
        "has-location-auto-create-on-goods-receipt-line-enabled": _vm.hasLocationAutoCreateOnGoodsReceiptLineEnabled
      },
      on: {
        "success": function (metadata) {
          return _vm.finishSpecialProcessingStep(specialProcess.methods.getIdentifier(), true, metadata);
        },
        "fail": function ($event) {
          _vm.finishSpecialProcessingStep(specialProcess.methods.getIdentifier(), false);
        }
      }
    });
  }), 1)], 1)], 1)], 1), _c('b-card', {
    ref: "sorting-location-scan",
    staticClass: "mb-1",
    class: {
      inactive: !_vm.isStepActive('sorting-location-scan')
    },
    attrs: {
      "no-body": ""
    }
  }, [_c('b-card-header', {
    staticClass: "text-left py-2 pl-3"
  }, [_c('b-card-title', {
    staticClass: "m-0"
  }, [_vm._v("SCAN LEGPLAATS")])], 1), _c('b-collapse', {
    attrs: {
      "id": "accordion-sorting-location-scan",
      "accordion": "orderpicking-steps"
    }
  }, [_c('b-card-body', {
    staticClass: "p-3"
  }, [_vm.sortingLocation && _vm.isStepActive('sorting-location-scan') ? _c('sorting-location-scan', {
    key: _vm.currentStep,
    attrs: {
      "storage-zone-identifier": _vm.storageZoneIdentifier,
      "location": _vm.location,
      "batch-model-type": _vm.batchModelType,
      "batch-model-identifier": _vm.batchModelIdentifier,
      "process-type": _vm.processType,
      "storage-location-identifier": _vm.sortingLocation.identifier,
      "storage-location-display-name": _vm.sortingLocation.display_name,
      "product-identifier": _vm.productIdentifier,
      "quantity": _vm.quantity,
      "dispatch-request": _vm.dispatchRequest,
      "special-processing-steps-result": _vm.specialProcessingIdentifiersCompleted
    },
    on: {
      "success": _vm.finishSortingLocationScan
    }
  }) : _vm._e()], 1)], 1)], 1), _c('b-card', {
    ref: "order-completion",
    staticClass: "mb-1",
    class: {
      inactive: !_vm.isStepActive('order-completion')
    },
    attrs: {
      "no-body": ""
    }
  }, [_c('b-card-header', {
    staticClass: "text-left py-2 pl-3"
  }, [_c('b-card-title', {
    staticClass: "m-0"
  }, [_vm._v(" ORDER COMPLEET "), _vm.isStepActive('order-completion') && _vm.countOrderCompletionSteps > 1 ? _c('span', [_vm._v(" (" + _vm._s(_vm.countOrderCompletionSteps - _vm.orderCompletionProcessIdentifiers.length) + "/" + _vm._s(_vm.countOrderCompletionSteps) + ") ")]) : _vm._e()])], 1), _c('b-collapse', {
    attrs: {
      "id": "accordion-order-completion",
      "accordion": "orderpicking-steps"
    }
  }, [_c('b-card-body', {
    staticClass: "p-3"
  }, [_c('b-collapse', {
    key: (_vm$currentOrderCompl = _vm.currentOrderCompletionProcess) === null || _vm$currentOrderCompl === void 0 ? void 0 : _vm$currentOrderCompl.name,
    attrs: {
      "id": "order-completion-container",
      "visible": "",
      "appear": _vm.countOrderCompletionSteps - _vm.orderCompletionProcessIdentifiers.length !== 1
    }
  }, _vm._l(_vm.ORDER_COMPLETION_PROCESSES, function (orderCompletionProcess) {
    return _c(orderCompletionProcess, {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: orderCompletionProcess.methods.getIdentifier() === _vm.currentOrderCompletionProcess,
        expression: "orderCompletionProcess.methods.getIdentifier() === currentOrderCompletionProcess"
      }],
      key: orderCompletionProcess.methods.getIdentifier() + _vm.scanCycle,
      ref: orderCompletionProcess.methods.getIdentifier(),
      refInFor: true,
      tag: "component",
      attrs: {
        "batch-model-type": _vm.batchModelType,
        "dispatch-request": _vm.dispatchRequest
      },
      on: {
        "success": function (newDrqData) {
          return _vm.finishOrderCompletionStep(newDrqData !== null && newDrqData !== void 0 ? newDrqData : {});
        },
        "fail": _vm.nextStep
      }
    });
  }), 1)], 1)], 1)], 1)], 1)])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }